import { render, staticRenderFns } from "./SaveUpSettleIn.vue?vue&type=template&id=8fe80b96&scoped=true&"
import script from "./SaveUpSettleIn.vue?vue&type=script&lang=js&"
export * from "./SaveUpSettleIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe80b96",
  null
  
)

export default component.exports